












import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { PayoutRequest } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import PayoutRequestsView from "./components/PayoutRequestsView.vue";

const usePendingPrimaryBalance = () => {
  const { balance, getBalance } = useBalance();
  const { authUserStrict } = useAuthUser();
  const pendingBalance = ref<number>(0);
  const primaryBalance = computed<number>(() => balance.value - pendingBalance.value);
  const getPendingBalance = async () => {
    const balance = await providers.TransactionProvider.getPendingBalance({ userIds: [authUserStrict.value.id] });
    pendingBalance.value = balance[authUserStrict.value.id];
  };
  watch(
    balance,
    () => {
      getPendingBalance();
    },
    { immediate: true }
  );

  return {
    pendingBalance,
    primaryBalance,
    getBalance,
  };
};

export default defineComponent({
  name: "PagePayoutRequests",
  components: { PayoutRequestsView },
  setup() {
    const { getBalance, pendingBalance, primaryBalance } = usePendingPrimaryBalance();
    const { authUserStrict } = useAuthUser();

    const loading = ref(false);
    const { enableScroll, items: requestsList, getFirstPage, getNextPage, addItem } = usePager(page => {
      return providers.PayoutRequestsProvider.search({
        data: { userId: authUserStrict.value.id, page, sort: "TIME,DESC" },
      });
    });

    const hasActiveRequest = computed(() => requestsList.value.some(i => i.status === "NEW") ?? false);

    const onCreateRequest = (value: PayoutRequest) => {
      addItem(value, "start");
    };

    const getData = async () => {
      try {
        loading.value = true;
        await Promise.all([getFirstPage(), getBalance()]);
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      enableScroll,
      requestsList,
      hasActiveRequest,
      pendingBalance,
      primaryBalance,
      getNextPage,
      onCreateRequest,
    };
  },
});
